import { apiRequest } from "../util/apiUtils";

export const cryptoList = async (params) => {
  try {
    const res = await apiRequest("get", `market-data/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const cryptoStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `market-data/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};